import {ComponentPropsFromRoute} from "../../../routers/routers";
import React, {useMemo} from "react";
import FilteredTable from "../../core/commons/filtered-table/filtered.table";
import {FilterDataController} from "../../../controllers/filtered-table/filter.data.controller";
import {useTranslation} from "react-i18next";
import {columnsFactory} from "./statements-list.columns";
import {StatementFile} from "../../../models/accounting/statements";
import {statementsFilesService} from "../../../services/accounting/statements-files.service";
import {RootStoreContext} from "../../../stores/root/root";
import {useRequiredLayers} from "../../../utils/context";
import {RootControllersContext} from "../../../controllers/root/root.controllers";

interface StatementsFilesListProps extends ComponentPropsFromRoute {}

export const StatementsFilesList: React.FC<StatementsFilesListProps> = () => {

    const {t} = useTranslation("translation", {useSuspense: false});

    const {controller: {loginController}} = useRequiredLayers(RootStoreContext, RootControllersContext)

    const dataHandler: FilterDataController<StatementFile> = useMemo(() => new FilterDataController(request => statementsFilesService.getList(request)), []);

    const columns = useMemo(() => columnsFactory(t, loginController.generateUri), []);

    return (
        <>
            <FilteredTable
                columns={columns}
                dataHandler={dataHandler}
            />
        </>
    )
}